import { render, staticRenderFns } from "./ProductTile.vue?vue&type=template&id=af5f87e8&scoped=true&"
import script from "./ProductTile.vue?vue&type=script&lang=js&"
export * from "./ProductTile.vue?vue&type=script&lang=js&"
import style0 from "./ProductTile.vue?vue&type=style&index=0&id=af5f87e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5f87e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af5f87e8')) {
      api.createRecord('af5f87e8', component.options)
    } else {
      api.reload('af5f87e8', component.options)
    }
    module.hot.accept("./ProductTile.vue?vue&type=template&id=af5f87e8&scoped=true&", function () {
      api.rerender('af5f87e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/ProductTile.vue"
export default component.exports